import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export class QueryBuilderNetworkService {
  // * query builder field options *//
  static getQueryBuilderFieldDynamicOptions(data: any) {
    const { id, search } = data;
    const searchPath = search ? `?search=${search}` : "";
    return http.get(
      `${consoleBaseUrl}${Endpoints.DYNAMIC_FIELD_OPTIONS}/${id}/options${searchPath}`
    );
  }
  // * query builder field options as per module name *//
  static getQueryBuilderFieldDynamicOptionsAsPerModuleName(data: any) {
    const { id, module_name, search } = data;
    const searchPath = search ? `?search=${search}` : "";
    return http.get(
      `${consoleBaseUrl}${Endpoints.DYNAMIC_FIELD_OPTIONS_MODULEWISE}/${module_name}/field/${id}/options${searchPath}`
    );
  }

  static getQueryBuilderMappingFields(data: any) {
    const { id, segment_type } = data;
    // Construct the query parameters in one variable
    const queryParams = new URLSearchParams();
    if (id) {
      queryParams.append('list_id', id);
    }
  
    if (segment_type) {
      queryParams.append('segment_type', segment_type);
    }
  
    // Convert the queryParams object to a string and append to the URL
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
  
    return http.get(
      `${consoleBaseUrl}${Endpoints.GET_FIELDS_TYPE_MAPPING_LIST}${queryString}`
    );
  }
  static getShopifyMappingFields(data: any) {
    const { id } = data;
    return http.get(`${consoleBaseUrl}${Endpoints.SHOPIFY_FIELD_OPTIONS}${id}`);
  }
  static getWooCommerceMappingFields(data: any) {
    const { id } = data;
    return http.get(`${consoleBaseUrl}${Endpoints.WOOCOMMERCE_FIELD_OPTIONS}${id}`);
  }
}

class Endpoints {
  static DYNAMIC_FIELD_OPTIONS = "/workspace/contact-properties/field";
  static DYNAMIC_FIELD_OPTIONS_MODULEWISE = "/workspace/module-properties";
  static SHOPIFY_FIELD_OPTIONS =
    "/workspace/ecommerce-properties/fields/shopify/";
  static WOOCOMMERCE_FIELD_OPTIONS =
    "/workspace/ecommerce-properties/fields/woocommerce/";
  
  //new endpoints for node microservice
  static GET_FIELDS_TYPE_MAPPING_LIST = "/workspace/broadcast/fields_type_mapping_list";
}
